import { useContext } from "react";
import { ITranslationScopeContext, TranslationScopeContext } from "../translation-scope";

function  useTranslation(): ITranslationScopeContext {
    const scopeContext = useContext(TranslationScopeContext);
    /** check if the component is inside <TranslationScope ...> component */
    if (!scopeContext?.getTranslation) {
        throw new Error('Missing TranslationScope component above Translation component/hook');
    }

    return scopeContext;
}

export default useTranslation;
